module.exports = __webpack_public_path__ + "img/backgroud.57732bf6.png";